module.exports = __webpack_public_path__ + "img/moodtrack1_1.aa35c78a.png";